<template>
  <div class="cv-modal">
    <v-dialog
      v-model="isVisible"
      max-width="556"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="cv-modal__title headline"
          primary-title
        >
          CV
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form ref="cvForm" v-model="isFormValid" @submit.prevent="submitForm">
            <v-row>
              <v-col class="cv-modal__col">
                <v-textarea
                  v-model="recommendation"
                  class="cv-modal__text"
                  validate-on-blur
                  solo
                  flat
                  hide-details
                  label="Developer recommendation"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="cv-modal__col">
                <v-text-field
                  v-if="recommendation && recommendation.length"
                  v-model="score"
                  class="form-field"
                  :rules="[rules.required, rules.minScore, rules.maxScore]"
                  validate-on-blur
                  dense
                  label="Developer score*"
                  type="number"
                  placeholder="Type number"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="cv-modal__col">
                <v-text-field
                  v-model="rateWithMargin"
                  class="form-field"
                  dense
                  suffix="/ h"
                  label="Type hourly rate with margin"
                  type="number"
                  placeholder="Type number"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="cv-modal__col">
                <v-switch
                  v-model="isBlind"
                  class="mt-0"
                  :disabled="processing"
                  color="blue"
                  label="Blind CV"
                ></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="cv-modal__actions">
          <v-btn
            color="blue"
            class="white--text"
            large
            min-width="256"
            :loading="processing"
            @click="submitForm"
          >
            Generate CV
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';

const rules = validationRules;

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },

    developerScore: {
      type: [Number, String],
      required: false,
      default: null,
    },

    rate: {
      type: [Number, String],
      default: null,
    },
  },

  data() {
    return {
      rules,
      isFormValid: true,
      processing: false,
      recommendation: '',
      score: null,
      isBlind: false,
      rateWithMargin: null,
    };
  },

  computed: {
    ...mapState('hrDeveloper', [
      'developer',
    ]),

    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    isVisible() {
      this.recommendation = this.isVisible ? this.developer.recommendation : '';
      this.score = this.isVisible ? this.developerScore : null;
      this.rateWithMargin = this.isVisible ? this.rate : null;
    },
  },

  methods: {
    ...mapActions('hrDeveloper', [
      'updateDeveloper',
      'generateDeveloperCv',
    ]),

    closeModal() {
      this.$emit('input', false);
    },

    submitForm() {
      this.$refs.cvForm.validate();

      if (this.isFormValid) {
        const cvData = {
          developerId: this.developer.personal_data.id,
          cvParams: {
            recommendation: this.recommendation,
            score: this.recommendation && this.recommendation.length ? this.score : null,
            is_blind_cv: this.isBlind,
            rate_with_margin: this.rateWithMargin,
          },
        };

        this.processing = true;

        this.generateDeveloperCv(cvData)
          .then((resp) => {
            const fileName = `${this.developer.personal_data.last_name}-${this.developer.personal_data.first_name}`;
            const downloadLink = document.createElement('a');
            downloadLink.target = '_blank';
            downloadLink.download = `cv-${fileName}.pdf`;

            const blob = new Blob([resp.data], { type: 'application/pdf' });
            const URL = window.URL || window.webkitURL;
            const downloadUrl = URL.createObjectURL(blob);
            downloadLink.href = downloadUrl;
            document.body.append(downloadLink);
            downloadLink.click();

            document.body.removeChild(downloadLink);
            URL.revokeObjectURL(downloadUrl);

            this.$emit('success');
          })
          .finally(() => {
            this.processing = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cv-modal {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
    justify-content: flex-end;
  }

  &__col {
    padding-bottom: 4px;
  }

  &__text {
    border: 1px solid #E2E6EA;
  }
}
</style>
